import type { Branch, CashSession } from '@/lib/types';
import { PrintService } from './PrintService';
import { buildCashSessionHTML } from './cashSessionTemplate';
import type { PaperWidth, PrintResult } from './printTypes';

export interface PrintCashSessionOptions {
  branch: Branch | null;
  session: CashSession;
  currencySymbol?: string;
  paperWidth?: PaperWidth;
  copies?: number;
  printerName?: string | null;
}

/** Imprime el cuadre de caja por la capa única de impresión. */
export async function printCashSession(
  options: PrintCashSessionOptions
): Promise<PrintResult> {
  const {
    branch,
    session,
    currencySymbol = 'RD$',
    paperWidth = '80mm',
    copies = 1,
    printerName,
  } = options;

  const html = buildCashSessionHTML({ branch, session, currencySymbol, paperWidth });

  return PrintService.printHTML(html, {
    paperWidth,
    copies,
    printerName: printerName ?? undefined,
  });
}